import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GaEventsService {

  constructor() { }

  trackEvent(eventName: string, eventParams: object) {
    gtag('event', eventName, eventParams);
  }

  trackButtonClick(eventName: string) {
    window.parent.postMessage(eventName, environment.webbtreeWebsiteUrl);
  }
}
